// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"42cf5ee9","584":"bab681ad","620":"fef14bfd","949":"4134805a"}[chunkId] + ".chunk.css";
};